import React from 'react';
import { useDropzone } from 'react-dropzone';
import { Upload } from '@mui/icons-material';
import Box from '@mui/material/Box';

export function UploadBox({
    placeholder,
    error,
    disabled,
    sx,
    ...other
}) {
    const { getRootProps, getInputProps, isDragActive, isDragReject } =
        useDropzone({
            disabled,
            ...other,
        });

    const hasError = isDragReject || error;

    return (
        <Box
            {...getRootProps()}
            sx={{
                width: 64,
                height: 64,
                flexShrink: 0,
                display: 'flex',
                borderRadius: 1,
                cursor: 'pointer',
                alignItems: 'center',
                color: 'text.disabled',
                justifyContent: 'center',
                ...(isDragActive && { opacity: 0.72 }),
                ...(disabled && { opacity: 0.48, pointerEvents: 'none' }),
                ...(hasError && {
                    color: 'error.main',
                    borderColor: 'error.main',
                }),
                '&:hover': { opacity: 0.72 },
                ...sx,
            }}
        >
            <input {...getInputProps()} />

            {placeholder || <Upload sx={{ width: 28 }} />}
        </Box>
    );
}